import { useLocation } from '@reach/router'
import React from 'react'

import { WebViewDomChanges } from './WebViewDomChanges'
import Header from '../Header'
import HeaderClub from '../HeaderClub'
import HeaderTelesales from '../HeaderTelesales'
import { useStoreContext } from '../../../contexts/StoreContext'
import { canInactivateStore } from '../../../../utils/canInactivateStore'
import { IS_WEBVIEW } from '../../../constants'

interface CommonHeaderRenderProps {
  isClubHeader: boolean
}

const CommonHeaderRender = ({ isClubHeader }: CommonHeaderRenderProps) => {
  const { hasInactiveStore, account } = useStoreContext()
  const isInactiveStore =
    hasInactiveStore && canInactivateStore.includes(account)

  const location = useLocation()
  const isTelesalesLocation = location.pathname.includes('/vendas-whatsapp')

  if (IS_WEBVIEW || isInactiveStore) {
    return <WebViewDomChanges />
  }

  if (isClubHeader) {
    return <HeaderClub />
  }

  if (isTelesalesLocation) {
    return <HeaderTelesales />
  }

  return <Header />
}

export default CommonHeaderRender
